import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';

import { colorsPalettes } from '@similarweb/styles';

import { Modal } from '../../../../components/Modal';
import { useDispatchTrackEventWithLocation } from '../../../../services/tracking/hooks/useDispatchTrackEventWithLocation';
import { ContactUsSuccessModal } from '../../../settings/ContactUsSuccessModal/ContactUsSuccessModal';
import { useUpdatePackage } from '../../../settings/PackageUpgradeBlock/useUpdatePackage';

import { StyledContactUsHistorycalDataButton, StyledIcon, StyledTextBlock } from './styles';

export const ContactUsHistorycalData = ({ numberOfMonths }: { numberOfMonths: number }) => {
  const dispatchTrackEventWithLocation = useDispatchTrackEventWithLocation();
  const { isHookModalOpen, setIsHookModalOpen, onOpenModalAndSendContactUsRequest } = useUpdatePackage();

  const handleClick = () => {
    dispatchTrackEventWithLocation('hooks', 'contact us', `historical data hook/${numberOfMonths}`);
    onOpenModalAndSendContactUsRequest();
  };

  const { t } = useTranslation();

  return (
    <>
      <StyledContactUsHistorycalDataButton onClick={handleClick}>
        <StyledIcon iconName="calendar-locked" size="sm" iconColor={colorsPalettes.indigo[300]} />
        <StyledTextBlock>{t('company.contact_us.historical_data')}</StyledTextBlock>
      </StyledContactUsHistorycalDataButton>
      {createPortal(
        <Modal isOpen={isHookModalOpen} onClose={() => setIsHookModalOpen(false)}>
          <ContactUsSuccessModal />
        </Modal>,
        document.body
      )}
    </>
  );
};
